module.exports = __webpack_public_path__ + "static/fonts/GT-America-Standard-Light.dbd1756.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/GT-America-Standard-Light.ttf
// module id = 1170
// module chunks = 0